<form [formGroup]="note">
    <div class="titles">
        <mat-form-field>
            <mat-label>Dropdown Title</mat-label>
            <input matInput formControlName="DropTitle">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Notes Title</mat-label>
            <input matInput formControlName="NotesTitle">
        </mat-form-field>
    </div>
    <div>
        <div>
            <button mat-button (click)="addSelection()">Add Selection</button>
        </div>
        <div class="dropdownentries">
            <ng-container *ngFor="let drop of DropdownEntries.controls; index as i">
                <app-dropdownentry 
                [dropdownentry]="drop" 
                [index]="i"
                [last]="DropdownEntries.controls.length - 1" 
                (moveEntry)="onMoveEntry($event)" 
                (delete)="onDelete($event)"></app-dropdownentry>
            </ng-container>
        </div>
    </div>
</form>